/* eslint-disable jsx-a11y/img-redundant-alt */
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { useEffect, useState } from "react";
import { toast, Bounce } from "react-toastify";
import { useAudio, useAudioList } from "../Stores/useAudio";
import { usePlayGif, useGifList } from "../Stores/useGif";
import { useDispatch } from "react-redux";
import { checkMultiClaims, getAllValue, getClaims } from "../../action";

export const NewLOE = () => {
  const [address, setAddress] = useState("");
  const [clientName, setClientName] = useState("");
  const [insurerName, setInsurerName] = useState("");
  const [description, setDescription] = useState("");
  const [userId, setUserId] = useState("");

  const { setAudioURL } = useAudio();
  const { chaching } = useAudioList();
  const { setGifSrc, setShowGif } = usePlayGif();
  const { moneyCatGif } = useGifList();
  const dispatch = useDispatch();

  const jwtToken = localStorage.getItem("jwtToken");

  useEffect(() => {
    if (jwtToken) {
      try {
        const decoded = jwtDecode(jwtToken);
        if (decoded && decoded.id) {
          setUserId(decoded.id);
        } else {
          console.log("ID not found in decoded JWT");
        }
      } catch (error) {
        console.error("Error decoding the token:", error);
      }
    } else {
      console.log("No JWT token found in localStorage.");
    }
  }, [jwtToken]);

  const submitNewLOE = () => {
    if (address === "") {
      toast.warn("Please enter the address of the property!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
    } else if (clientName === "") {
      toast.warn("Please enter the client name!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
    } else if (insurerName === "") {
      toast.warn("Please enter the insurer name!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
    } else if (description === "") {
      toast.warn("Please enter property damage details!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
    } else {
      axios.post("https://api.claimdefenderaigame.com:5000/api/claims/create",
          {
            userId,
            address,
            claimantName: clientName,
            insurerName,
            description,
          },
          {
            headers: {
              Authorization: `Bearer ${jwtToken}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          if (res.data.success) {
            toast.success("Successfully created!", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
              theme: "colored",
              transition: Bounce,
            });
            if (res.data.badgeUnlock === "") {
              dispatch({ type: "SET_CAT_GIFT", payload: "+50 points" });
              setAudioURL(chaching);
            } else if (res.data.badgeUnlock.includes("First claim added")) {
              dispatch({ type: "SET_CAT_GIFT", payload: "+50 points, 'First claim added' badge added, You’ve earned this badge simply by creating first claim!" });
              setAudioURL(["/sounds/badge/badge1.mp3"]);
            } else if (res.data.badgeUnlock.includes("5 claims added")) {
              dispatch({ type: "SET_CAT_GIFT", payload: "+50 points, '5 claims added' badge added, You’ve earned this badge by creating 5 claims!" });
              setAudioURL(["/sounds/badge/badge2.mp3"]);
            } else if (res.data.badgeUnlock.includes("Case Juggler")) {
              dispatch({ type: "SET_CAT_GIFT", payload: "+50 points, 'Case Juggler' badge added, You’ve earned this badge by 20+ active cases at once!" });
              setAudioURL(["/sounds/badge/badge14.mp3"]);
            } else {
              dispatch({ type: "SET_BADGE_GIFT", payload: `added ${res.data.badgeUnlock} badges!` })
              setAudioURL(["/sounds/badge/badge20.mp3"]);
            }
            dispatch({ type: "GET_ALL_BADGE", payload: res.data.badge });
            dispatch(getAllValue());
            dispatch(getClaims());
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  return (
    <div className="relative bg-white shadow-sm p-6 border rounded-lg">
      <h2 className="mb-4 font-bold text-xl">Submit New LOE</h2>
      <div className="flex flex-col gap-y-4 font-medium">
        <div className="flex flex-col">
          <p>Property Address</p>
          <input
            className="p-2 border-b outline-none hover:outline-none"
            type="text"
            placeholder="Enter the property address"
            onChange={(e) => setAddress(e.target.value)}
          />
        </div>
        <div className="flex flex-col">
          <p>Client Name</p>
          <input
            className="p-2 border-b outline-none hover:outline-none"
            type="text"
            onChange={(e) => setClientName(e.target.value)}
          />
        </div>
        <div className="flex flex-col">
          <p>Insurer Name</p>
          <input
            className="p-2 border-b outline-none hover:outline-none"
            type="text"
            onChange={(e) => setInsurerName(e.target.value)}
          />
        </div>
        <div className="flex flex-col">
          <p>Description</p>
          <input
            className="p-2 border-b outline-none hover:outline-none"
            type="text"
            placeholder="Enter property damage details"
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>
        <button
          onClick={submitNewLOE}
          className="bg-blue-600 active:bg-blue-900 py-2 rounded-lg text-white"
        >
          Add New LOE
        </button>
      </div>
    </div>
  );
};
